import axios from "axios";
const headers =  {
    'Authorization': 'Bearer ' + localStorage.getItem('user-token'),
        'Content-type': 'application/json'
}
export const updateUserProfileService = (user,id)=>{

  return  axios.post(window.API_URL+'users/profile/'+id, user,headers)
}